import { Checkbox } from "antd";
import {
  IInteractiveModLocation,
  LocationTarget,
  interactiveLocationTargetTypes,
  modTypes,
} from "@blings/blings-player";
import { DynamicValueMod } from "../../DynamicValueMod";
import {
  LOCATION_DATA_EXAMPLE,
  LOCATION_EXPRESSION_EXAMPLE,
  LOCATION_SCALAR_SOURCE_HELP,
  createEmptyLocationTarget,
  createLocationDataSchema,
} from "../../locationConnector";
import { LocationTargetEditor } from "./LocationTargetEditor";

export const LocationSourceEditor = ({
  change,
  index,
  onChange,
}: {
  change: IInteractiveModLocation;
  index: number;
  onChange: (index: number, keys: any, values: any) => void;
}) => (
  <DynamicValueMod<modTypes.interactiveLocation>
    change={change}
    index={index}
    onChange={onChange}
    dividerText="Location source"
    dataFieldConfig={{
      schema: createLocationDataSchema(),
      value: LOCATION_DATA_EXAMPLE,
    }}
    expressionPlaceholder={LOCATION_EXPRESSION_EXAMPLE}
    expressionTooltipText="Return an address string or a structured location target. You can use the data and control objects."
    sourceDefaults={{
      value: createEmptyLocationTarget(
        interactiveLocationTargetTypes.coordinates,
      ),
      expression: LOCATION_EXPRESSION_EXAMPLE,
    }}
    sourceHelpText={LOCATION_SCALAR_SOURCE_HELP}
    renderValueEditor={({ value, onChange: updateValue }) => (
      <LocationTargetEditor
        value={
          value && typeof value === "object"
            ? (value as LocationTarget)
            : undefined
        }
        action={change.action}
        onChange={updateValue}
      />
    )}
    renderDefaultValueEditor={({ value, onChange: updateDefaultValue }) => (
      <div className="location-fallback-editor">
        <Checkbox
          checked={typeof value !== "undefined"}
          onChange={(event) =>
            updateDefaultValue(
              event.target.checked
                ? createEmptyLocationTarget(
                    interactiveLocationTargetTypes.coordinates,
                  )
                : undefined,
            )
          }
        >
          Use a fallback location
        </Checkbox>
        {typeof value !== "undefined" && (
          <LocationTargetEditor
            value={
              typeof value === "object" ? (value as LocationTarget) : undefined
            }
            action={change.action}
            onChange={updateDefaultValue}
          />
        )}
      </div>
    )}
  />
);
